import { AppComponentBase } from '@shared/common/app-component-base';
import { Component, Input, Injector } from '@angular/core';

@Component({
    selector: 'app-label',
    template: `
        <label>
            <ng-content></ng-content>
            @if (required) {
                <span class="text-danger">*</span>
            }
        </label>
    `,
    standalone: false,
})
export class AppLabelComponent extends AppComponentBase {
    @Input() required: boolean;

    constructor(injector: Injector) {
        super(injector);
    }
}
